import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const NotFound = () => {
    return (
        <>
            <Navbar />
            <section id="body-wrap" style={{ minHeight: "70vh", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{ textAlign: "center" }}>
                            <h2 style={{ fontSize: "5rem", marginBottom: "1rem" }}>404 ERROR</h2>
                            <h1>SORRY, THIS PAGE IS NOT AVAILABLE!!!</h1>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default NotFound